import { Injectable } from '@angular/core'
import { ChecklistItem } from '@awork/features/task/models/checklist-item'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'

@Injectable({ providedIn: 'root' })
export class ChecklistItemStore extends EntitySignalStore<ChecklistItem> {
  constructor() {
    super({
      name: 'checklistItem',
      entityConstructor: checklistItem => new ChecklistItem(checklistItem),
      nullableProps: ['order']
    })
  }
}
